import { TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { DeletedBy } from '@/common/soft-delete';
import { cn, formatDateTime } from '@/lib/utils';

type DeletedItemBannerProps = {
	/** "asset", "inspection", … in the reader's language */
	itemLabel: string;
	deletedAt: string | null | undefined;
	deletedBy?: DeletedBy;
	className?: string;
};

/**
 * Warning on a deleted item opened as a read-only preview (GH #331). Restore sits where the item's Delete
 * button is (RestoreItemButton).
 */
export function DeletedItemBanner({ itemLabel, deletedAt, deletedBy, className }: DeletedItemBannerProps) {
	const { t } = useTranslation();
	const date = deletedAt ? formatDateTime(deletedAt) : '';
	return (
		<div
			className={cn('rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm', className)}
			role="alert"
		>
			<p className="flex items-start gap-2 text-destructive">
				<TriangleAlert className="mt-0.5 size-4 shrink-0" />
				<span>
					<span className="font-medium">
						{deletedBy
							? t('common.deleted.itemBannerBy', { item: itemLabel, date, name: deletedBy.name })
							: t('common.deleted.itemBanner', { item: itemLabel, date })}
					</span>{' '}
					{t('common.deleted.itemReadOnly')}
				</span>
			</p>
		</div>
	);
}
